const footerLinks = {
  快速导航: [
    { label: '实时快讯', href: '#updates' },
    { label: '热门爆料', href: '#cards' },
    { label: '热度榜单', href: '#ranking' },
    { label: '话题广场', href: '#topics' },
    { label: '焦点专题', href: '#carousel' },
  ],
  关于平台: [
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
    { label: '投稿爆料', href: '#contact' },
    { label: '移动端下载', href: '#app' },
  ],
  内容分类: [
    { label: '顶流明星', href: '#index' },
    { label: '综艺内幕', href: '#index' },
    { label: '网红专区', href: '#index' },
    { label: '影视爆料', href: '#index' },
  ],
};

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <span className="text-xl font-heading font-bold text-background-50 mb-4 block">
              每日黑料
            </span>
            <p className="text-sm leading-relaxed text-background-50/60 max-w-sm">
              每日黑料网是全网黑料吃瓜内容的核心入口与首页，为你提供每日更新的热门爆料与争议事件导航。覆盖微博热搜、豆瓣八卦、抖音快讯等多渠道信源，做中文互联网最全面的黑料每日吃瓜平台导航。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{title}</h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-50/50 hover:text-primary-400 transition-colors no-underline cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-6 mb-6">
          <h3 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h3>
          <p className="text-xs text-background-50/40">优质合作站点持续招募中，欢迎联系洽谈合作</p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-background-50/10">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 每日黑料网。本站为内容聚合导航平台，不生产任何爆料内容。理性吃瓜，文明上网。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors no-underline cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors no-underline cursor-pointer">用户协议</a>
            <a href="#contact" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors no-underline cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}